import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TemplateState {
  selectedTemplate: "blank" | "housing" | null;
}

const initialState: TemplateState = {
  selectedTemplate: null,
};

const templateSlice = createSlice({
  name: "template",
  initialState,
  reducers: {
    setSelectedTemplate: (
      state,
      action: PayloadAction<"blank" | "housing" | null>
    ) => {
      state.selectedTemplate = action.payload;
    },
  },
});

export const { setSelectedTemplate } = templateSlice.actions;
export default templateSlice.reducer;